module.exports = __webpack_public_path__ + "static/img/sy-3.bb08948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-3.png
// module id = GdRQ
// module chunks = 63